import React, { useState, useEffect } from "react";
import { Alert, TextField, Button, Grid, Stack, CircularProgress, Box } from "@mui/material";
import { updateUser, auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import AddressField from "./AddressField";
import { PageShell, PageHeader, PageContent, Section } from "./Page";

const Edit = () => {
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");
  const [user, setUser] = useState(null);
  const [loadingData, setLoadingData] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  const handleDisplayNameChange = (event) => {
    setDisplayName(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handlePointChange = (event) => {
    setPoint(event.target.value);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      if (!user) {
        setLoadingData(false);
        return;
      }

      // Precargar los datos que el usuario ya tiene guardados
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setDisplayName(userData.displayName || "");
          setPhone(userData.phone || "");
          setPoint(userData.point || "");
        }
      } catch {
        // Error ignorado intencionalmente
      } finally {
        setLoadingData(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async () => {
    if (!user) return;
    setSaving(true);
    setStatus(null);
    try {
      await updateUser(user.uid, displayName, phone, point);
      setStatus({ severity: "success", message: "Los cambios se guardaron correctamente." });
    } catch (error) {
      setStatus({ severity: "error", message: "No se pudieron guardar los cambios. Intentá de nuevo." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageShell>
      <PageHeader title="Editar perfil" subtitle="Actualizá tus datos de contacto" />
      <PageContent>
        <Section title="Datos personales" description="Así te verán los compradores cuando consulten por tus vehículos.">
          {loadingData ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress color="secondary" />
            </Box>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Nombre"
                    value={displayName}
                    onChange={handleDisplayNameChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Teléfono"
                    value={phone}
                    onChange={handlePhoneChange}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <AddressField
                    label="Dirección"
                    name="point"
                    value={point}
                    onChange={handlePointChange}
                  />
                </Grid>
              </Grid>
              {status && (
                <Alert severity={status.severity} sx={{ mt: 3 }}>
                  {status.message}
                </Alert>
              )}
              <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  onClick={handleSubmit}
                  disabled={saving}
                >
                  {saving ? "Guardando..." : "Guardar cambios"}
                </Button>
              </Stack>
            </>
          )}
        </Section>
      </PageContent>
    </PageShell>
  );
};

export default Edit;
